import React, { FunctionComponent, useRef } from "react";

import { getCustomization } from "@multiweb/customization";
import { DataRowElementSiblings, getDataRowSibling, GetDataRowSiblingType, TAB_INDEX_FOCUSABLE_ONLY, TAB_INDEX_FOCUSABLE_TAB_SEQUENCE } from "@multiweb/reactUtils";
import { DataRowVariant } from "../../../components";
import { DataRow } from "../../../components/DataRow";
import { GRID_PARTICIPANTS_TEMPLATE_RENDERER_KEY, ROLE_USERS_ATTRIBUTE_CLASS_NAME } from "../../constants";
import { GRID_PARTICIPANTS_ITEM_CLASS_NAME as classNames } from "./constants";

export type GridParticipantsItemProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Příznak, zda se zobrazuje Templeta pod DataRow komponentou */
    expandRoleUsers: boolean;
    /** Identifikace záznamu. */
    recordId: string;
    /** Zda je záznam první, využito ve stylech. */
    isFirst: boolean | undefined;
    /** Zda je záznam poslední, využito ve stylech. */
    isLast: boolean | undefined;
    /** Klíč pro templatu, která se zobrazí pod DataRow. */
    templateKey: string;
};

export const GridParticipantsItem: FunctionComponent<GridParticipantsItemProps> = ({
    dataSourceKey,
    recordId,
    expandRoleUsers,
    isFirst,
    isLast,
    templateKey,
},
) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const Template = getCustomization().liteListFrame.templates.getRendererByKey(templateKey).component;

    const getNestedSibling: GetDataRowSiblingType = (siblingType: DataRowElementSiblings) => {
        if (expandRoleUsers) {
            if (siblingType === DataRowElementSiblings.nextElementSibling) {
                const firstUserRoleRow = containerRef.current?.querySelector(`.${ROLE_USERS_ATTRIBUTE_CLASS_NAME()}`)?.firstChild;

                if (firstUserRoleRow) {
                    return firstUserRoleRow as HTMLElement;
                }
            } else if (siblingType === DataRowElementSiblings.previousElementSibling) {
                const lastUserRoleRow = getDataRowSibling(siblingType, containerRef.current)?.querySelector(`.${ROLE_USERS_ATTRIBUTE_CLASS_NAME()}`)?.lastChild;
                if (lastUserRoleRow) {
                    return lastUserRoleRow as HTMLElement;
                }
            }
        }

        return getDataRowSibling(siblingType, containerRef.current)?.firstChild as HTMLElement;
    };

    return (
        <div className={classNames({ isFirst, isLast })} ref={containerRef}>
            <DataRow
                templateRendererKey={ GRID_PARTICIPANTS_TEMPLATE_RENDERER_KEY }
                explicitTabIndex={isFirst ? TAB_INDEX_FOCUSABLE_TAB_SEQUENCE : TAB_INDEX_FOCUSABLE_ONLY}
                variant={DataRowVariant.gridParticipants}
                disableShiftKey
                {... { dataSourceKey, recordId, getSibling: getNestedSibling }}
            />
            {expandRoleUsers &&
                <Template {...{ dataSourceKey, recordId }} />
            }
        </div>
    );
};
